import { parameterAPI } from 'src/api/modules/parameters';
import notice from 'src/common/components/Notice';

const getAppParams = async (keyParam) => {
	parameterAPI
		.getParameterKey(keyParam)
		.then((response) => {
			localStorage.setItem(
				response.parametros[0].clave,
				response.parametros[0].valor
			);
		})
		.catch((e) => {
			notice('Ocurrio un error al obtener usuario de minos', 'error');
		});
};

export { getAppParams };
